<template>
    <transition name="fade" v-if="enableTool">
        <control-layers
            :moduleCode="moduleCode"
            :enableToolMapLayers="enableTool"
            :posBtnMap="mapButtons.layers.position"
            :idxBtnMap="mapButtons.layers.order"
            :showLabelBtnMap="mapButtons.layers.showLabel"
            :collapsible="mapButtons.layers.collapsible"
            :collapsed="initialCollapsedExpandCollapse"
            :showButtonOnActionMap="showButtonOnActionMap"
        >
        </control-layers>
    </transition>
</template>

<script>
    import ToolMixin from './mixins/ToolMixin';

    export default {
        mixins: [
            ToolMixin,
        ],
        components: {
            'control-layers': () => import(/* webpackChunkName: "control-layers" */ '@/components/maps/control/layersControl'),
        },
        data() {
            return {
                pageID: 'layers'
            }
        },
    }
</script>